import { Required, IsString, DataValidator, transformKeys, IsStringOrNumber, IsNumber } from "@/utils/type-vaildator";
import api from "./api";

export interface PushInfoDataTemplateListRequest {
  userId: string;
  agentId: string;
  type: "video" | "podcast" | "moments" | "post" | "article" | "image";
  page?: number;
  pageSize?: number;
}

interface PushInfoDataTemplateListResponse {
  data: any[];
}

export class UserTemplateItemData {
  @Required("Id cannot be empty")
  // @IsNumber("Id must be a number")
  id: number | string;

  @Required("Uuid cannot be empty")
  @IsString("Uuid must be a string")
  uuid: string;

  @Required("Template name cannot be empty")
  @IsString("Template name must be a string")
  templateName: string;

  @IsString("Cover url must be a string")
  coverUrl?: string;

  @IsString("Cover video must be a string")
  coverVideo?: string;

  @IsNumber("Template resource must be a number")
  templateResource?: number;

  @IsString("Scene must be a string")
  scene?: string;

  // 仅在短视频模板才有
  @IsString("Voice model id must be a string")
  voiceModelId?: string;

  speedRatio?: number;
}

export const pushInfoDataTemplateList = async ({
  agentId,
  type,
  page = 1,
  pageSize = 20,
}: PushInfoDataTemplateListRequest): Promise<UserTemplateItemData[]> => {
  const typeMap = { video: 1, podcast: 2, moments: 3, post: 4, image: 4, article: 5 } as const;
  if (!agentId) throw new Error("agentId cannot be empty");
  if (!(type in typeMap)) throw new Error(`Invalid template type: ${type}`);
  if (page <= 0) throw new Error("page must be greater than 0");
  if (pageSize <= 0) throw new Error("pageSize must be greater than 0");

  const response = await api.post<PushInfoDataTemplateListResponse>("push_info_data_template/list", {
    agent_id: agentId,
    type: typeMap[type],
    page,
    page_size: pageSize,
  });
  const root = transformKeys(response.data);
  const list = Array.isArray(root.data) ? root.data : [];
  return list.map((item: any) => DataValidator.validateOrThrow(item, UserTemplateItemData));
}